// @flow

export const LEVELS = 'debug info warn error'.split(' ');

export default {};
